"use strict";

import $ from "jquery";
import { default as initMap, setMarker, showInfoBoxByMarker } from "./leaflet-map";

export function initInScope($scope) {
    let $maps = $scope.find('.js-energy-map');

    if ($maps && $maps.length) {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const minZoomValue = isMobile ? 7 : 8;

        $maps.each(function (index, element) {
            let $container = $(element);
            let $mapCanvas = $container.find('.js-energy-map__canvas');

            import('leaflet').then(function () {
                // console.log('Leaflet Map geladen');

                const poiStyles = {
                    PV: {
                        default: L.icon({
                            iconUrl: '/static/img/energy-map/marker--pv.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        }),
                        active: L.icon({
                            iconUrl: '/static/img/energy-map/marker--pv--active.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        })
                    },
                    Hydropower: {
                        default: L.icon({
                            iconUrl: '/static/img/energy-map/marker--hydropower.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        }),
                        active: L.icon({
                            iconUrl: '/static/img/energy-map/marker--hydropower--active.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        })
                    },
                    CleanEnergy: {
                        default: L.icon({
                            iconUrl: '/static/img/energy-map/marker--cleanenergy.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        }),
                        active: L.icon({
                            iconUrl: '/static/img/energy-map/marker--cleanenergy--active.svg',
                            iconSize: [80, 80],
                            popupAnchor: [0, -25],
                        })
                    }
                };

                const mapOptions = {
                    center: {lat: 47.3768866, lng: 8.541694},
                    zoom: 15,
                    minZoom: minZoomValue,
                    maxBounds: [
                        [45.817993, 5.955911],
                        [47.808455, 10.492294]
                    ],
                    maxBoundsViscosity: 1
                };

                const infoBoxOptions = {
                    className: 'energy-map__info-box',
                };

                let clusteringOptions = {
                    showCoverageOnHover: false,
                    maxClusterRadius: 10,
                    iconCreateFunction: function(cluster) {
                        return L.divIcon({
                            iconSize: [92, 92],
                            className: 'marker-cluster',
                            html: '<img class="marker-cluster__img" src="/static/img/energy-map/marker--cluster.svg"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span>'
                        });
                    }
                };

                let poiVarName = $container.data('energy-map-pois');
                let pois = [];

                if (poiVarName) {
                    if (!window['_energyMapPois']) {
                        console.error('_energyMapPois ist nicht gesetzt');
                    } else if (!window._energyMapPois[poiVarName]) {
                        console.error(poiVarName + ' ist nicht in _energyMapPois gesetzt', _energyMapPois);
                    } else {
                        pois = _energyMapPois[poiVarName];
                        // console.log('pois', pois);
                    }
                }

                let mapObj = initMap({
                    element: $mapCanvas[0],
                    mapOptions,
                    clustering: true,
                    clusteringOptions,
                    poiStyles,
                    onActivateMarker,
                    onDeactivateMarker,
                    infoBoxOptions
                });

                if (pois) {
                    setMarker(mapObj, pois);
                }
            }).catch(function (a, b, c) {
                console.error(a, b, c);
            });
        });
    }
}

let currentActiveMarker = null;

function onActivateMarker(marker, mapObj) {
    if (currentActiveMarker && currentActiveMarker !== marker) {
        currentActiveMarker.closePopup();
    }
    currentActiveMarker = marker;

    const infoBoxContent = `${marker.detailInfo}`;
    showInfoBoxByMarker(marker, infoBoxContent, mapObj);
}

function onDeactivateMarker(marker, mapObj) {}